export default __webpack_public_path__ + "static/media/manaur.9863db5c.svg";